import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CurrencyValue,
  Flex,
  LineChart,
  formatNumber
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useChartPeriod } from '@/hooks';

export default function HistoricChart({ symbol }) {
  const { address, walletAddress } = useParams();
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/tokens/arbitrum/${address}/holders/${walletAddress}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const datasets = useMemo(() => {
    return [
      {
        xField: 'date',
        yField: 'balance'
      }
    ];
  }, []);

  const yScaleValueFormatter = (value) => {
    return formatNumber(Number(value));
  };

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <CurrencyValue
          value={Number(value)}
          options={{
            currency: tokensMapping(symbol),
            iconSize: '3'
          }}
        />
      );
    }
    return formatValue;
  }, [symbol]);

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          key="balance"
          data={data}
          valueFormatter={valueFormatter}
          datasets={datasets}
          yScaleValueFormatter={yScaleValueFormatter}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
